import compatModules from '@embroider/virtual/compat-modules';

export const registry: Record<string, unknown> = {
  ...compatModules,
};
